<template>
    <v-menu offset-y tile attach=".v-app-bar" left>
        <template #activator="{ on }">
            <v-btn v-on="on" outlined plain height="40" class="px-2">
                <v-icon>mdi-account</v-icon>
            </v-btn>
        </template>
        <v-list dense dark>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title style="font-size: 18px; font-weight: 500">
                        <template v-if="account.Email">{{account.Email}}</template>
                        <template v-else>demo</template>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="workspace">role: {{workspace.role}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon :to="{name: 'logout'}" title="logout"><v-icon>mdi-logout-variant</v-icon></v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-divider />
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title v-if="workspace" style="font-size: 20px; font-weight: 500">
                        {{workspace.name}}
                    </v-list-item-title>
                    <v-list-item-subtitle>workspace</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon :to="{name: 'workspaces'}" title="switch"><v-icon>mdi-swap-horizontal</v-icon></v-btn>
                </v-list-item-action>
            </v-list-item>
<!--            <v-divider />-->
<!--            <v-list-item link :to="{name: 'settings'}">-->
<!--                Personal settings-->
<!--            </v-list-item>-->
        </v-list>
    </v-menu>
</template>

<script>
export default {
    props: {
        workspace: Object,
        account: Object,
    }
}
</script>

<style scoped>
</style>
